"use client";

import { cn } from "@deputy-ai/common";
import { Button } from "@deputy-ai/ui/button/Button";
import { Popover } from "@deputy-ai/ui/popover/Popover";
import data from "@emoji-mart/data";
import enI18n from "@emoji-mart/data/i18n/en.json";
import zhI18n from "@emoji-mart/data/i18n/zh.json";
import Picker from "@emoji-mart/react";
import { forwardRef } from "react";
import { HiOutlineFaceSmile } from "react-icons/hi2";

export interface EmojiElementProps {
  id: string;
  native: string;
}

interface EmojiPickerProps {
  onPicker: (e: EmojiElementProps) => void;
  locale?: string;
  disabled?: boolean;
}

const I18N_MAP: Record<string, typeof enI18n | typeof zhI18n> = {
  en: enI18n,
  zh: zhI18n,
};

export const EmojiPicker = forwardRef<HTMLDivElement, EmojiPickerProps>(
  (props, ref) => {
    const locale = window.navigator.language;
    const { onPicker, disabled } = props;
    return (
      <div>
        <Popover>
          <Popover.Trigger asChild>
            <Button
              size="sm"
              variant="ghost"
              icon={<HiOutlineFaceSmile />}
              className={cn(disabled && "cursor-not-allowed")}
              disabled={disabled}
              onClick={(e) => e.stopPropagation()}
            ></Button>
          </Popover.Trigger>
          <Popover.Content className="w-auto border-0 p-0">
            <Picker
              data={data}
              onEmojiSelect={onPicker}
              i18n={I18N_MAP[locale]}
            />
          </Popover.Content>
        </Popover>
      </div>
    );
  }
);

EmojiPicker.displayName = "EmojiPicker";
